import React from 'react';
import { fireEvent, render, waitFor } from '@testing-library/react';
import Login from './Login';
import * as services from './services';

const props = {
  csrfToken: '123abc',
  dealerId: '12345678',
};

jest.mock('./services');

describe('Login', () => {
  describe('Validations', () => {
    it('renders correctly', () => {
      const { getByText, getByLabelText } = render(<Login {...props} />);
      expect(getByText('Log In to Portal')).toBeInTheDocument();
      expect(getByLabelText('Username or Email')).toBeInTheDocument();
    });

    it('disables login button when identity is empty', () => {
      const { getByRole } = render(<Login {...props} />);
      const loginButton = getByRole('button', { name: 'Log In' });
      expect(loginButton).toBeDisabled();
    });

    it('enables login button when identity is provided', () => {
      const { getByRole, getByLabelText } = render(<Login {...props} />);
      const identityField = getByLabelText('Username or Email');
      fireEvent.change(identityField, { target: { value: 'testuser' } });
      const loginButton = getByRole('button', { name: 'Log In' });
      expect(loginButton).toBeEnabled();
    });

    it('shows password field if postCheckSso returns allow_password_login true', async () => {
      services.postCheckUsernameSso.mockResolvedValueOnce({
        json: async () => ({ allow_password_login: true }),
      });

      const { getByLabelText, queryByLabelText, getByRole } = render(
        <Login {...props} />,
      );
      const identityField = getByLabelText('Username or Email');
      fireEvent.change(identityField, { target: { value: 'testuser' } });

      const loginButton = getByRole('button', { name: 'Log In' });
      fireEvent.click(loginButton);

      await waitFor(() => {
        expect(queryByLabelText('Password')).toBeInTheDocument();
      });

      expect(getByRole('button', { name: 'Log In' })).toBeDisabled();
    });

    it('redirects to redirect_url if postCheckSso returns requires_sso true', async () => {
      const mockRedirectUrl = '/sso-redirect';
      services.postCheckUsernameSso.mockResolvedValueOnce({
        json: async () => ({
          requires_sso: true,
          redirect_url: mockRedirectUrl,
        }),
      });

      delete window.location;
      window.location = { href: '' };

      const { getByLabelText, getByRole } = render(<Login {...props} />);
      const identityField = getByLabelText('Username or Email');
      fireEvent.change(identityField, { target: { value: 'testuser' } });

      const loginButton = getByRole('button', { name: 'Log In' });
      fireEvent.click(loginButton);

      await waitFor(() => {
        expect(window.location.href).toBe(mockRedirectUrl);
      });
    });

    it('submits form when Enter key is pressed on username field', async () => {
      services.postCheckUsernameSso.mockResolvedValueOnce({
        json: async () => ({ allow_password_login: true }),
      });

      const { getByLabelText } = render(<Login {...props} />);
      const identityField = getByLabelText('Username or Email');
      fireEvent.change(identityField, { target: { value: 'testuser' } });

      // Press Enter on the username field
      fireEvent.keyPress(identityField, {
        key: 'Enter',
        code: 'Enter',
        charCode: 13,
      });

      await waitFor(() => {
        expect(services.postCheckUsernameSso).toHaveBeenCalledWith(
          props.csrfToken,
          'testuser',
        );
      });
    });
  });
});

describe('Request password', () => {
  it('disables request button if form is invalid', async () => {
    const { getByRole } = render(
      <Login defaultScreen="PasswordReset" {...props} />,
    );

    const sendButton = getByRole('button', { name: 'Send Link' });
    expect(sendButton).toBeDisabled();
  });

  it('enables request button if form is valid', async () => {
    const { getByRole, getByLabelText } = render(
      <Login defaultScreen="PasswordReset" {...props} />,
    );

    const identityField = getByLabelText('Username or Email');

    const sendButton = getByRole('button', { name: 'Send Link' });

    fireEvent.change(identityField, { target: { value: 'username' } });

    expect(sendButton).toBeEnabled();
  });
});
